const de = {
  common: {
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    phone: 'Telefon',
    email: 'E-Mail',
    office: 'Büro',
    availability: 'Verfügbarkeit',
    support: 'Support',
    preOrder: 'Vorbestellung',
    clearForm: 'Formular leeren',
    sending: 'Wird gesendet...',
    select: 'Auswählen',
    closeNotification: 'Benachrichtigung schließen',
  },
  nav: {
    home: 'Startseite',
    about: 'Über uns',
    preOrder: 'Vorbestellung',
    contacts: 'Kontakte',
    startPreOrder: 'Vorbestellung starten',
    openMenu: 'Menü öffnen',
    closeMenu: 'Menü schließen',
    logoAria: 'KUB AUTO Startseite',
    languageSwitcher: 'Sprache',
  },
  seo: {
    defaultTitle: 'KUB AUTO — Premium-Fahrzeugvorbestellung in ganz Europa',
    defaultDescription: 'Auswahl, Prüfung, Kauf und Lieferung von Premium-Fahrzeugen in ganz Europa mit festen Bedingungen und rechtlicher Sicherheit.',
    home: {
      title: 'KUB AUTO — Premium-Fahrzeugvorbestellung in ganz Europa',
      description: 'Auswahl, Prüfung, Kauf und Lieferung von Premium-Fahrzeugen in ganz Europa mit festen Bedingungen und rechtlicher Sicherheit.',
    },
    about: {
      title: 'Über KUB AUTO — Service für Premium-Fahrzeugbeschaffung',
      description: 'Erfahren Sie, wie KUB AUTO die Suche, Prüfung, Vertragsabwicklung, Logistik und Übergabe von Premium-Fahrzeugen in ganz Europa organisiert.',
    },
    preOrder: {
      title: 'Vorbestellformular — Fahrzeuganforderungen übermitteln | KUB AUTO',
      description: 'Übermitteln Sie Ihre Anforderungen an ein Premium-Fahrzeug und erhalten Sie geprüfte Optionen, klare Konditionen und einen vertragsbasierten Prozess.',
    },
    contacts: {
      title: 'Kontakte — KUB AUTO Concierge',
      description: 'Kontaktieren Sie KUB AUTO per WhatsApp, Telegram oder E-Mail für Beratung zu Premium-Fahrzeugen und Vorbestellungen.',
    },
  },
  home: {
    gallery: {
      kicker: 'AUSGEWÄHLTE FAHRZEUGE',
      title: 'Reale Premium-Fahrzeuge aus aktuellen Beschaffungen',
      sub: 'Eine Auswahl realer Fahrzeuge, die wir kürzlich beschafft und geliefert haben. Jedes Auto steht für unsere hohen Ansprüche an Qualität, Prüfung und Service.',
    },
    hero: {
      kicker: 'PRIVATER BESCHAFFUNGSSERVICE',
      title: 'Premium-Fahrzeuge per individueller Vorbestellung',
      lead: 'Auswahl, Prüfung, Kauf und Lieferung in ganz Europa — mit festen Bedingungen und rechtlicher Sicherheit.',
      cta: 'Vorbestellung starten',
      pills: ['Vertragsbasiert', 'Offizielle Datenbanken', 'Komplette Betreuung'],
      cardTitle: 'Was Sie erhalten',
      badge: 'STANDARD',
      bullets: [
        'Dokumentierter Prozess und feste Gebühren',
        'Technische und rechtliche Prüfung vor dem Kauf',
        'Logistik, Zoll, Zertifizierung und Übergabe',
      ],
    },
    process: {
      title: 'Der Prozess',
      sub: 'Klar, dokumentiert, vorhersehbar.',
      steps: [
        { title: 'Anfrage', sub: 'Anforderungen' },
        { title: 'Marktanalyse', sub: 'Geprüfte Quellen' },
        { title: 'Prüfung', sub: 'Rechtlich + technisch' },
        { title: 'Vertrag', sub: 'Feste Bedingungen' },
        { title: 'Lieferung', sub: 'Übergabe' },
      ],
      ctaTitle: 'Übermitteln Sie Ihre Anforderungen — wir melden uns mit geprüften Optionen zurück',
      ctaText: 'Die übliche Suchdauer beträgt einige Tage bis zu zwei Wochen.',
      cta: 'Vorbestellung starten',
    },
    trust: {
      title: 'Warum Kunden uns vertrauen',
      sub: 'Transparenz + rechtliche Sicherheit während der gesamten Transaktion.',
      cards: [
        { title: 'Formeller Vertrag', text: 'Gebühren, Schritte und Fristen sind festgelegt.' },
        { title: 'Prüfung', text: 'Offizielle Datenbanken + Berichte.' },
        { title: 'Komplettservice', text: 'Logistik, Zoll, Zertifizierung.' },
      ],
      missionTitle: 'Reglementiertes Verfahren',
      missionText: 'Auswahl → Prüfung → Abstimmung → Vertrag → Kauf → Lieferung → Übergabe. Jeder Schritt ist dokumentiert.',
      cta: 'Beratung erhalten',
    },
    reviewsFaq: {
      reviewsTitle: 'Kundenstimmen',
      reviewsSub: 'Kurzes Feedback von Kunden, denen Vorhersehbarkeit, Klarheit und Kontrolle wichtig sind.',
      reviews: [
        {
          quote: '„Alles entsprach genau dem, was wir vereinbart hatten.“',
          text: 'Klare Schritte, regelmäßige Updates und kein Druck. Preis und Zeitplan blieben wie besprochen, und die Übergabe verlief reibungslos.',
          meta: 'Andrius Kazlauskas, Vilnius (LT)',
        },
        {
          quote: '„Ich wusste in jeder Phase, was gerade passiert.“',
          text: 'Sie schickten Optionen mit allen Details, erklärten, worauf man achten sollte, und kümmerten sich sauber um die Unterlagen. Keine unnötigen Anrufe, nur klare Kommunikation.',
          meta: 'Nerijus Šimkus, Kaunas (LT)',
        },
        {
          quote: '„Das Auto kam genau so an, wie es beschrieben wurde.“',
          text: 'Die Prüfergebnisse wurden im Voraus geteilt, die Logistik ohne Verzögerungen organisiert und die Dokumente rechtzeitig vorbereitet. Insgesamt ein professioneller und ruhiger Ablauf.',
          meta: 'Mārtiņš Pētersons, Riga (LV)',
        },
      ],
      faqTitle: 'FAQ',
      faqSub: 'Antworten auf die häufigsten Fragen zum Prozess.',
      faq: [
        { q: 'Wie starte ich eine Vorbestellung?', a: 'Senden Sie ein Vorbestellformular mit Ihren Anforderungen. Wir bestätigen die Details und beginnen mit der Suche.' },
        { q: 'Wie lange dauert die Fahrzeugsuche?', a: 'In der Regel von einigen Tagen bis zu zwei Wochen, abhängig von der Komplexität der Anforderungen.' },
        { q: 'Wie werden Fahrzeuge geprüft?', a: 'Jedes Fahrzeug wird technisch und rechtlich mithilfe offizieller Datenbanken und Prüfberichte überprüft.' },
        { q: 'Wann wird der Vertrag unterzeichnet?', a: 'Nachdem Sie ein konkretes Fahrzeug freigegeben haben und alle Bedingungen abgestimmt sind.' },
        { q: 'Welche Kosten werden im Voraus fixiert?', a: 'Servicegebühr, Logistik, Zollabwicklung und obligatorische Gebühren werden im Vertrag festgelegt.' },
        { q: 'Was passiert nach dem Fahrzeugkauf?', a: 'Wir organisieren Logistik, Zollabwicklung, Zertifizierung und Vorbereitung zur Übergabe.' },
        { q: 'Wann erhalte ich das Fahrzeug?', a: 'Nach Abschluss aller Verfahren und Prüfung der Dokumente wird das Fahrzeug an Sie übergeben.' },
        { q: 'Kann ich ein ausgewähltes Fahrzeug ablehnen?', a: 'Ja. Die Suche wird fortgesetzt, bis ein Fahrzeug freigegeben wird, das Ihre Anforderungen vollständig erfüllt.' },
        { q: 'Arbeiten Sie mit Unternehmen ebenso wie mit Privatkunden?', a: 'Ja. Wir arbeiten sowohl mit Privatpersonen als auch mit juristischen Personen auf Vertragsbasis.' },
        { q: 'In welchen Ländern suchen Sie Fahrzeuge?', a: 'Wir suchen Fahrzeuge in ganz Europa und arbeiten nur mit geprüften Lieferanten und Auktionsplattformen.' },
        { q: 'Sind Lieferung und Zollabwicklung enthalten?', a: 'Ja. Vollständige Logistik, Zollabwicklung und Zertifizierung sind Teil unseres Services.' },
      ],
    },
    finalCta: {
      kicker: 'BEREIT LOSZULEGEN',
      title: 'Starten Sie Ihre Vorbestellungsanfrage',
      sub: 'Wir melden uns mit geprüften Optionen und klaren Bedingungen.',
      cta: 'Zur Vorbestellung',
    },
  },
  about: {
    hero: {
      kicker: 'ÜBER DAS UNTERNEHMEN',
      title: 'Premium-Fahrzeuge per individueller Vorbestellung in ganz Europa',
      lead: 'Wir bieten professionelle Auswahl, Prüfung und Beschaffung von Premium-Fahrzeugen nach individuellen Kundenanforderungen mit vollständiger rechtlicher und logistischer Betreuung — von der ersten Suche bis zur finalen Übergabe.',
      cta: 'Vorbestellungsanfrage senden',
    },
    overview: {
      title: 'Allgemeiner Überblick',
      sub: 'Unsere Leistungen sind für Kunden konzipiert, die Transparenz, strukturierte Prozesse und rechtliche Sicherheit schätzen.',
      cards: [
        {
          title: 'Tätigkeitsbereich',
          text: 'Das Unternehmen ist auf die Suche, Prüfung und den Kauf von Premium-Fahrzeugen auf dem europäischen Markt spezialisiert, einschließlich offizieller Händler, geprüfter Lieferanten und Auktionsplattformen. Alle Schritte — von der ersten Auswahl bis zur Fahrzeugübergabe — werden nach einem einheitlichen Qualitätsstandard und innerhalb vereinbarter Fristen ausgeführt.',
        },
        {
          title: 'Komplette Betreuung',
          text: 'Wir bieten die Fahrzeugauswahl anhand definierter Parameter, dokumentierte technische und rechtliche Prüfung, Fixierung von Leistungsumfang und Preis im Vertrag sowie Organisation von Kauf, Logistik, Zollabwicklung, Zertifizierung und Vorbereitung des Fahrzeugs für die finale Übergabe.',
        },
      ],
    },
    principles: {
      title: 'Arbeitsprinzipien',
      sub: 'Ein strukturierter, dokumentierter Prozess mit klarer Verantwortung in jeder Phase.',
      cards: [
        { icon: '✓', title: 'Formalität und Transparenz', text: 'Alle Phasen der Zusammenarbeit und Servicegebühren werden vertraglich festgehalten. Der Kunde hat vollständige Klarheit über Prozess, Fristen und Pflichten jeder Partei.' },
        { icon: '🧾', title: 'Umfassende Fahrzeugprüfung', text: 'Jedes Fahrzeug wird technisch und rechtlich anhand offizieller Datenbanken, Servicehistorie und bei Bedarf durch eine unabhängige Experteninspektion geprüft.' },
        { icon: '🎯', title: 'Individueller Ansatz', text: 'Die Fahrzeugsuche erfolgt strikt entsprechend Budget, Präferenzen und Verwendungszweck des Kunden — ohne zufällige oder ungeeignete Angebote.' },
        { icon: '🛡', title: 'Vollständige Unterstützung', text: 'Wir organisieren Kauf, Logistik, Zollabwicklung, Zertifizierung und Vorbereitung des Fahrzeugs zur Übergabe und minimieren Risiken sowie den Aufwand für den Kunden.' },
      ],
    },
    advantages: {
      title: 'Wesentliche Vorteile',
      sub: 'Warum Kunden eine individuelle Vorbestellung mit professioneller Betreuung wählen.',
      items: [
        'Nachgewiesene Expertise im Premium-Automobilsegment',
        'Zusammenarbeit ausschließlich mit geprüften Lieferanten und Auktionsplattformen',
        'Klar strukturierter Workflow und strikte Einhaltung vereinbarter Termine',
        'Verantwortung für Ergebnisse in jeder Phase der Transaktion',
      ],
    },
    mission: {
      kicker: 'MISSION',
      title: 'Zugang zu Premium-Fahrzeugen mit garantierter Qualität und rechtlicher Sicherheit ermöglichen.',
      text: 'Wir liefern einen strukturierten, transparenten und professionellen Service in jeder Phase — von der ersten Auswahl bis zur finalen Übergabe des Fahrzeugs mit vollständiger Dokumentation.',
      ctaPrimary: 'Vorbestellungsanfrage senden',
      ctaSecondary: 'Kontakt aufnehmen',
    },
    process: {
      title: 'So funktioniert der Vorbestellungsprozess',
      sub: 'Ein aufeinander aufbauendes Verfahren mit definierten Stufen und Kontrollpunkten.',
      steps: [
        { num: '01', title: 'Anfrage', text: 'Sie senden Fahrzeugparameter und individuelle Anforderungen.' },
        { num: '02', title: 'Auswahl', text: 'Wir suchen und präsentieren geprüfte Fahrzeugoptionen, die Ihren Kriterien entsprechen.' },
        { num: '03', title: 'Vertrag', text: 'Alle Bedingungen, Schritte und Servicegebühren werden vertraglich fixiert.' },
        { num: '04', title: 'Kauf & Logistik', text: 'Wir organisieren Kauf, Lieferung, Zollabwicklung und Zertifizierung.' },
        { num: '05', title: 'Übergabe', text: 'Das Fahrzeug wird vorbereitet und mit vollständigem Dokumentensatz übergeben.' },
      ],
      ctaPrimary: 'Vorbestellungsanfrage senden',
      ctaSecondary: 'Frage auf Telegram stellen',
    },
  },
  contacts: {
    hero: {
      kicker: 'KONTAKTE',
      title: 'Kontakt aufnehmen',
      lead: 'Der schnellste Weg: WhatsApp. Für Beratung und Vorbestellungen sind wir rund um die Uhr erreichbar.',
    },
    primary: {
      title: 'KUB AUTO Concierge',
      emailUs: 'E-Mail senden',
      telegramCta: 'Lieber Telegram? Chat öffnen →',
    },
    office: {
      label: 'Büroadresse',
      address: 'Dzūkų g. 6a, Vilnius, 02163 Vilniaus m. sav.',
      badge: '24/7',
      hoursLabel: 'Arbeitszeiten',
      hoursValue: '24/7',
      supportLabel: 'Support',
      supportValue: 'WhatsApp / E-Mail',
      preOrderLabel: 'Vorbestellung',
      preOrderValue: 'Vertragsbasierter Prozess',
      openMaps: 'In Google Maps öffnen',
      mapTitle: 'KUB AUTO Bürokarte',
    },
    form: {
      title: 'Kurze Nachricht',
      sub: 'Hinterlassen Sie eine kurze Nachricht — wir antworten so schnell wie möglich.',
      nameLabel: 'Ihr Name',
      namePlaceholder: 'Vollständiger Name',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'name@example.com',
      messageLabel: 'Nachricht',
      messagePlaceholder: 'Welches Auto suchen Sie? Budget, Baujahr, Laufleistung, Präferenzen...',
      submit: 'Nachricht senden',
      success: 'Nachricht erfolgreich gesendet. Wir melden uns bald bei Ihnen.',
      error: 'Nachricht konnte nicht gesendet werden.',
    },
  },
  preOrder: {
    hero: {
      kicker: 'VORBESTELLFORMULAR',
      title: 'Fahrzeuganforderungen übermitteln',
      lead: 'Wir prüfen Ihre Anfrage und antworten mit geprüften Optionen und klaren Bedingungen.',
    },
    vehicle: {
      title: 'Fahrzeugdetails',
      sub: 'Grundlegende Parameter, um die Suche zu starten.',
      make: 'Marke',
      makePlaceholder: 'z. B. BMW',
      model: 'Modell',
      modelPlaceholder: 'z. B. X5',
      year: 'Jahr',
      yearPlaceholder: 'z. B. 2020',
      mileage: 'Laufleistung (km)',
      mileagePlaceholder: 'z. B. 45000',
      fuelType: 'Kraftstoffart',
      bodyType: 'Karosserieform',
      preferences: 'Zusätzliche Wünsche',
      preferencesPlaceholder: 'Ausstattung, Farbe, Innenraum, Zustand, Nutzungshistorie, besondere Anforderungen...',
      fuelOptions: [
        { value: 'petrol', label: 'Benzin' },
        { value: 'diesel', label: 'Diesel' },
        { value: 'hybrid', label: 'Hybrid' },
        { value: 'electric', label: 'Elektro' },
      ],
      bodyOptions: [
        { value: 'sedan', label: 'Limousine' },
        { value: 'wagon', label: 'Kombi' },
        { value: 'coupe', label: 'Coupé' },
        { value: 'suv', label: 'SUV' },
        { value: 'hatchback', label: 'Schrägheck' },
        { value: 'other', label: 'Andere' },
      ],
    },
    buyer: {
      title: 'Käuferinformationen',
      sub: 'Für Vertrag und Kommunikation.',
      buyerType: 'Käufertyp',
      buyerTypeOptions: [
        { value: 'individual', label: 'Privatperson' },
        { value: 'company', label: 'Unternehmen' },
      ],
      buyerName: 'Name / Unternehmen',
      buyerNamePlaceholder: 'Vollständiger Name oder juristische Person',
      address: 'Adresse',
      addressPlaceholder: 'Straße, Stadt, Land',
      phone: 'Telefon',
      phonePlaceholder: '+370 688 03122',
      email: 'E-Mail',
      emailPlaceholder: 'name@example.com',
      submit: 'Anfrage senden',
      askWhatsapp: 'Per WhatsApp fragen',
      askTelegram: 'Per Telegram fragen',
      success: 'Anfrage erfolgreich gesendet. Wir kontaktieren Sie in Kürze.',
      error: 'Anfrage konnte nicht gesendet werden.',
    },
    validation: {
      required: 'Erforderlich',
      yearFormat: 'Verwenden Sie 4 Ziffern (z. B. 2020)',
      numbersOnly: 'Nur Zahlen',
      tooLong: 'Zu lang',
      invalidPhone: 'Verwenden Sie internationales Format, z. B. +37068803122',
      invalidEmail: 'Ungültige E-Mail',
      invalid: 'Ungültig',
    },
  },
  validation: {
    tooShort: 'Zu kurz',
    tooLong: 'Zu lang',
    required: 'Erforderlich',
    invalidEmail: 'Ungültige E-Mail',
    invalid: 'Ungültig',
    unknownError: 'Unbekannter Fehler',
  },
};

export default de;
